<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps({
    count: {
      type: Number,
      required: true,
    },
  })

  defineOptions({
    name: 'UnreadBadge',
  })

  const isVisible = computed(() => props.count > 0)
  const displayValue = computed(() => (props.count > 9 ? '9+' : String(props.count)))
</script>

<template>
  <div
    v-if="isVisible"
    class="flex h-4.5 min-w-4.5 items-center justify-center rounded-full bg-primary px-1 text-[0.625rem] font-semibold leading-none text-on-primary"
  >
    {{ displayValue }}
  </div>
</template>
